/* eslint-disable camelcase */
import { Controller } from "stimulus";
import { closeModal } from "../modal/utils";

/* Reason: ESLint gets this wrong, it's in a string literal. */
/* eslint-disable-next-line no-unused-vars */
const email_regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const form_fields = [
  "email",
  "first_name",
  "last_initial",
  "title",
  "content",
  "rating",
  "unit_id",
  "post_title",
  "post_name"
];

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.formCopy = this.formTarget.cloneNode(true);
  }

  rate(e) {
    let active = true;
    Array.from(e.target.parentNode.children).forEach(child => {
      child.classList.remove("active");
      if (active) child.classList.add("active");
      if (child === e.target) active = false;
    });
  }

  form_data() {
    const fields = form_fields.map(field => {
      const data = {};
      const sel = `[name="${field}"]`;
      let el = this.element.querySelector(sel);
      if (el.type === "radio")
        el = this.element.querySelector(`${sel}:checked`);
      if (el) data[field] = el.value;
      return data;
    });
    return Object.assign(...fields);
  }

  submit(e) {
    e.preventDefault();
    e.returnValue = false;

    const valid = this.validate();
    if (!valid) return;

    const data = this.form_data();
    const callback = this.success.bind(this);
    /* eslint-disable-next-line no-undef */
    Site.postJson("/post_review", data, callback);
  }

  validate() {
    let valid = true;
    const validators = [
      {
        condition: 'el.value !== ""',
        target: Array.from(this.element.querySelectorAll("[required]")),
        text: "Required",
        revalidate: "focusout"
      },
      {
        condition: "!!email_regex.test(el.value)",
        target: Array.from(this.element.querySelectorAll("[email]")),
        text: "Invalid Email Address",
        revalidate: "focusout"
      },
      {
        condition: 'el.querySelector("input:checked") !== null',
        target: this.element.querySelector(".star-rating"),
        text: "Required",
        revalidate: "click"
      }
    ];
    validators.forEach(validator => {
      const { target } = validator;
      const targets = Array.isArray(target) ? target : [target];
      targets.forEach(el => {
        const is_valid =
          typeof validator.condition === "string"
            ? /* eslint-disable-next-line no-eval */
              eval(validator.condition)
            : validator.condition;

        if (is_valid) {
          this.clearError(el);
        } else {
          this.addError(el, validator.text);
          if (!el.dataset.bound) {
            el.addEventListener(validator.revalidate, this.validate.bind(this));
            /* eslint-disable-next-line no-param-reassign  */
            el.dataset.bound = true;
          }
          valid = false;
        }
      });
    });
    return valid;
  }

  addError(el, message) {
    /* Make an error container if one doesn't exist */
    const hasError = el.parentNode.classList.contains("error");
    const wrapper = hasError ? el.parentNode : document.createElement("div");
    if (!hasError) {
      wrapper.classList.add("error");
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }

    /* If the message container exists, grab it, otherwise make one */
    const hasErrorContainer = !!wrapper.querySelector(".error-msg");
    const messageContainer = hasErrorContainer
      ? wrapper.querySelector(".error-msg")
      : document.createElement("div");
    // Will do nothing if this class is already on the element.
    messageContainer.classList.add("error-msg");
    // Set the error text.
    messageContainer.innerText = message;
    if (!hasErrorContainer) wrapper.appendChild(messageContainer);
  }

  clearError(el) {
    const parent = el.parentNode;
    if (parent.classList.contains("error")) {
      parent.parentNode.insertBefore(el, parent);
      // El.parentNode.removeChild(El) is an ie11 fix for El.remove()
      parent.parentNode.removeChild(parent);
    }
  }

  success(response) {
    if (response.success) {
      this.element.classList.add("success");
      const $this = this;
      setTimeout(() => {
        $this.formTarget.innerHTML = $this.formCopy.innerHTML;
        closeModal($this.element);
        $this.element.classList.remove("success");
      }, 5000);
    } else {
      let general_message = this.formTarget.querySelector(".general-message");
      if (!general_message) {
        general_message = document.createElement("div");
        general_message.classList.add("general-message");
        this.formTarget.append(general_message);
      }
      general_message.innerText = response.message;
    }
  }
}
